import { getEnv } from "@/env";

export const PRODUCT_INDEX_EN = getEnv(
  "NEXT_PUBLIC_ALGOLIA_PRODUCT_INDEX",
  "product",
);
export const PRODUCT_SUMMARY_INDEX_EN = getEnv(
  "NEXT_PUBLIC_ALGOLIA_PRODUCT_SUMMARY_INDEX",
  "rv_product_summary",
);
